import styled from 'styled-components';
import device from '../../mediaQueries';

export const MobileMarginButtonWrapper = styled.div`
  ${device.mobile`
      ${({ margin }) => (margin ? `margin: ${margin};` : null)};
  `}
`;
